module.exports = __webpack_public_path__ + "static/media/i.4a9b70c9.m4a";